import { launchTrackStorageKey } from '@/constants/commonConst.ts';
import type { IBaseTrackData, IExtraTrackData, IParamData } from '@/types/DataStore.ts';
import core from '@/core';
import { handleSetStorage } from './common.ts';

let pageEnterTime;
let trackerInst;
let dataStore;
export function handlePageLoad(opts) {
  console.log('page load: ', opts);
}
export function handlePageOpts({
  baseOpts,
  extraOpts,
}: { baseOpts?: IBaseTrackData; extraOpts?: IExtraTrackData } = {}) {
  const dataStore = core.getDataStoreInstance();
  dataStore.setPageDataSnap(extraOpts || {});
  if (baseOpts) {
    core.insert(baseOpts);
  }
  console.log('page load opts: ', baseOpts, extraOpts);
}
export function handlePageEnter(opts?: IParamData) {
  console.log('page enter: ', opts);
  pageEnterTime = new Date().getTime();
  core.track('enter', opts);
}
export function handlePageLeave(opts?: IParamData) {
  const pageLeaveTime = new Date().getTime();
  const timeDiff = pageLeaveTime - pageEnterTime;
  dataStore.setExtraDataObj({});
  core.track('leave', opts, {
    extraReportBase: {
      residenceTime: timeDiff,
    },
  });
}
export async function handleAppLaunch(opts?: IBaseTrackData & IExtraTrackData) {
  trackerInst = core.getTrackerInstance();
  dataStore = trackerInst.getDataStoreInstance();
  handleSetStorage(launchTrackStorageKey, opts);
  core.track('launch', opts?.param || {});
}
export function handleAppShow(opts?: IBaseTrackData & IExtraTrackData) {
  console.log('handleAppShow: ', opts);
  handleSetStorage(launchTrackStorageKey, opts);
}

const mpWxEvtHandle = {
  handleAppLaunch,
  handleAppShow,
  handlePageLoad,
  handlePageEnter,
  handlePageLeave,
  handlePageOpts,
};

export default mpWxEvtHandle;
